// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"31d48342","455":"d0903525","977":"5e869d39"}[chunkId] + ".chunk.js";
};